import packageInfo from '../../package.json';

export const environment = {
  appVersion: packageInfo.version,
  production: true,
  HTTP: 'https://qubebizuatbe.qubeposcloud-uat.com/api', //Server
  NOTIFICATION_ENDPOINT: 'https://qubebizuatbe.qubeposcloud-uat.com/Hubs/NotificationHub',
  // HTTP: 'http://43.156.166.193:5003/api', //Server
  // HTTP: 'http://localhost:5116/api', //Local
  // NOTIFICATION_ENDPOINT: 'http://43.156.166.193:5003/Hubs/NotificationHub',
  FILE_LOCATION: 'http://43.156.166.193/'
};
